import React, { useEffect, useState } from "react";
import { Box, Button, TextareaAutosize, Typography } from "@mui/material";
import PlaceIcon from "@mui/icons-material/Place";
import DisplayField from "./DisplayField";
import TextToggle from "../../../components/TextToggle";
import DirectionsIcon from "@mui/icons-material/Directions";
import urlEncodeAddress from "./urlEncodeAddress";
import { config } from "../../../style";
import ActivityCard from "./ActivityCard";
import DisplayTextBox from "./DisplayTextBox";
import axios from "axios";
import { getCodeUsingCountryName } from "../../../components/CountryPhoneCode";

function LocationCard({ item = {}, prepareDocumentData }) {
    const [venueCountryCode, setVenueCountryCode] = useState("");
    const [hotelCountryCode, setHotelCountryCode] = useState("");
    const dataRef = React.useRef(null);
    useEffect(() => {
        if (item.venueCountryGlobal) {
            setVenueCountryCode(getCodeUsingCountryName(item.venueCountryGlobal));
        }
        if (item.hotelCountryGlobal) {
            setHotelCountryCode(getCodeUsingCountryName(item.hotelCountryGlobal));
        }
        dataRef.current = dataRef.current || {};
        dataRef.current["Drive time"] = { value: getDriveTime(item), type: "text", side: "left", order: 3 };
        prepareDocumentData(item.id, dataRef.current);
    }, [item]);

    const getDriveTime = (item) => {
        let data = [];
        if (item.distanceFromVenue) {
            data.push(`Distance from Venue: ${item.distanceFromVenue}`);
        }
        if (item.distanceFromAirport) {
            data.push(`Distance from Airport: ${item.distanceFromAirport}`);
        }

        if (data.length > 0) {
            return data.join("<br>");
        }
        return "";
    };

    const getVenueAddress = (item) => {
        let data = [];
        if (item.venueStreet) {
            data.push(item.venueStreet);
        }
        if (item.venueStreet2) {
            data.push(item.venueStreet2);
        }
        if (item.venueCity) {
            data.push(item.venueCity);
        }
        if (item.venueState) {
            data.push(item.venueState);
        }
        if (item.venueCountryGlobal) {
            data.push(item.venueCountryGlobal);
        }
        if (item.venueZIP) {
            data.push(item.venueZIP);
        }
        return data.join(", ");
    };
    const getHotelAddress = (item) => {
        let data = [];
        if (item.hotelStreet) {
            data.push(item.hotelStreet);
        }
        if (item.hotelStreet2) {
            data.push(item.hotelStreet2);
        }
        if (item.hotelCity) {
            data.push(item.hotelCity);
        }
        if (item.hotelState) {
            data.push(item.hotelState);
        }
        if (item.hotelCountryGlobal) {
            data.push(item.hotelCountryGlobal);
        }
        if (item.hotelZipCode) {
            data.push(item.hotelZipCode);
        }
        return data.join(", ");
    };

    const displayAddress = (item) => {
        let venue = getVenueAddress(item);
        let hotel = getHotelAddress(item);

        if (venue === hotel && venue !== "") {
            return (
                <DisplayTextBox
                    title={"Venue/Hotel"}
                    value={
                        <>
                            <TextToggle
                                text={venue}
                                maxLines={2}
                                buttonSx={{
                                    textDecoration: "none",
                                    display: "block",
                                }}
                                showMoreText={"Show full address"}
                                showlessText={"Show less address"}></TextToggle>
                        </>
                    }
                    prepareData={(key, value) => prepareRightData(key, value, 1, venue)}
                />
            );
        }

        if (venue && hotel && venue !== hotel) {
            return (
                <>
                    <DisplayTextBox
                        title={"Venue"}
                        value={
                            <>
                                <TextToggle
                                    text={venue}
                                    maxLines={2}
                                    buttonSx={{
                                        textDecoration: "none",
                                        display: "block",
                                    }}
                                    showMoreText={"Show full address"}
                                    showlessText={"Show less address"}></TextToggle>
                            </>
                        }
                        prepareData={(key, value) => prepareRightData(key, value, 1, venue)}
                    />
                    <DisplayTextBox
                        title={"Hotel"}
                        value={
                            <>
                                <TextToggle
                                    text={hotel}
                                    maxLines={2}
                                    buttonSx={{
                                        textDecoration: "none",
                                        display: "block",
                                    }}
                                    showMoreText={"Show full address"}
                                    showlessText={"Show less address"}></TextToggle>
                            </>
                        }
                        prepareData={(key, value) => prepareRightData(key, value, 1, hotel)}
                    />
                </>
            );
        }

        if (venue || hotel) {
            return (
                <DisplayTextBox
                    title={venue ? "Venue" : "Hotel"}
                    value={
                        <>
                            <TextToggle
                                text={venue || hotel}
                                maxLines={2}
                                buttonSx={{
                                    textDecoration: "none",
                                    display: "block",
                                }}
                                showMoreText={"Show full address"}
                                showlessText={"Show less address"}></TextToggle>
                        </>
                    }
                    prepareData={(key, value) => prepareRightData(key, value, 1, venue || hotel)}
                />
            );
        }
        return "";
    };

    // async function getPhoneCode(countryName) {
    //     const res = await axios.get(`https://restcountries.com/v3.1/name/${countryName}`);
    //     return res.data[0]?.idd?.root + (res.data[0]?.idd?.suffixes?.[0] || "");
    // }

    const getPhone = (item) => {
        let venuePhoneNumber = item.venuePhoneNumber;
        let hotelPhoneNumber = item.hotelPhoneNumber;

        if (venuePhoneNumber && !venuePhoneNumber.startsWith("+") && item.venueCountryGlobal) {
            venuePhoneNumber = (venueCountryCode + " " || "") + venuePhoneNumber;
        }
        if (hotelPhoneNumber && !hotelPhoneNumber.startsWith("+") && item.hotelCountryGlobal) {
            hotelPhoneNumber = (hotelCountryCode + " " || "") + hotelPhoneNumber;
        }

        if (venuePhoneNumber && hotelPhoneNumber && venuePhoneNumber !== hotelPhoneNumber) {
            return (
                <>
                    <DisplayTextBox
                        title={"Venue Phone Number"}
                        value={venuePhoneNumber}
                        prepareData={(key, value) => prepareRightData(key, value, 3)}
                    />
                    <DisplayTextBox
                        title={"Hotel Phone Number"}
                        value={hotelPhoneNumber}
                        prepareData={(key, value) => prepareRightData(key, value, 3)}
                    />
                </>
            );
        }
        if (venuePhoneNumber && hotelPhoneNumber && venuePhoneNumber === hotelPhoneNumber) {
            return (
                <>
                    <DisplayTextBox
                        title={"Phone Number"}
                        value={venuePhoneNumber}
                        prepareData={(key, value) => prepareRightData(key, value, 3)}
                    />
                </>
            );
        }
        if (venuePhoneNumber) {
            return (
                <DisplayTextBox
                    title={"Venue Phone Number"}
                    value={venuePhoneNumber}
                    prepareData={(key, value) => prepareRightData(key, value, 3)}
                />
            );
        }
        if (hotelPhoneNumber) {
            return (
                <DisplayTextBox
                    title={"Hotel Phone Number"}
                    value={hotelPhoneNumber}
                    prepareData={(key, value) => prepareRightData(key, value, 3)}
                />
            );
        }
        return "";
    };

    const prepareLeftData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "left", order };
    };
    const prepareRightData = (key, value, order, mainText) => {
        dataRef.current = dataRef.current || {};
        if (mainText) {
            value.value = mainText;
        }
        dataRef.current[key] = { ...value, side: "right", order };
    };
    return (
        <ActivityCard
            label="Location"
            icon={<PlaceIcon fontSize="small" sx={{ color: config.primaryColor }}></PlaceIcon>}
            subject={item.subject}
            date={item.departureStartTimeString}
            timezone={item.departureTimeZoneCode}
            detail={
                <>
                    {item.roomType && (
                        <DisplayField
                            label="Room Type"
                            type="Text"
                            text={item.roomType}
                            prepareData={(key, value) => prepareLeftData(key, value, 1)}></DisplayField>
                    )}
                    {item.hotelBilling && (
                        <DisplayField
                            label="Billing Details"
                            type="Element"
                            element={
                                <Typography
                                    sx={{
                                        fontSize: "15px",
                                    }}>
                                    {item.hotelBilling}{" "}
                                </Typography>
                            }
                            prepareData={(key, value) => prepareLeftData(key, value, 2)}></DisplayField>
                    )}
                    {getDriveTime(item) && (
                        <DisplayField
                            label="Drive time"
                            type="Text"
                            text={getDriveTime(item)}
                            prepareData={(key, value) => prepareLeftData(key, value, 3)}></DisplayField>
                    )}

                    {item.locationNotes && (
                        <DisplayField
                            label="Additional Notes"
                            type="ShowMoreText"
                            element={item.locationNotes}
                            prepareData={(key, value) => prepareLeftData(key, value, 4)}></DisplayField>
                    )}
                </>
            }
            rightElement={
                <>
                    {displayAddress(item)}
                    {item.confirmation && (
                        <DisplayTextBox
                            title={"Confirmation #"}
                            value={item.confirmation}
                            prepareData={(key, value) => prepareRightData(key, value, 2)}
                        />
                    )}
                    {getPhone(item)}
                    {(getVenueAddress(item) || getHotelAddress(item)) && (
                        <>
                            <Button
                                startIcon={<DirectionsIcon fontSize="small" />}
                                href={`https://www.google.com/maps/dir/?api=1&destination=${urlEncodeAddress(
                                    item,
                                    getVenueAddress(item) ? "venue" : "hotel"
                                )}`}
                                size="small"
                                target="_blank"
                                variant="outlined">
                                Get Directions
                            </Button>
                            {prepareRightData(
                                "Get Directions",
                                {
                                    label: "Get Directions",
                                    value: `https://www.google.com/maps/dir/?api=1&destination=${urlEncodeAddress(
                                        item,
                                        getVenueAddress(item) ? "venue" : "hotel"
                                    )}`,
                                    type: "button",
                                    order: 10,
                                },
                                100
                            )}
                        </>
                    )}
                </>
            }></ActivityCard>
    );
}

const DisplayNotes = ({ heading = "", onChange = () => {} }) => {
    const [text, setText] = useState("");
    const handleChange = (e) => setText(e.target.value);

    return (
        <>
            <Typography
                component={"p"}
                variant="paraText6"
                color={"gray.main"}
                fontWeight={"fontWeightMedium"}
                marginTop="1rem"
                marginLeft={"4px"}>
                {heading || "Additional notes"}
            </Typography>
            <Box
                component={"span"}
                aria-label="additional-notes"
                placeholder="Type additional notes here..."
                sx={{
                    border: `1px solid #E9E9E9`,
                    background: "#FFFFFF",
                    borderRadius: "8px",
                    fontSize: "14px",
                    padding: "0.5rem 0.8rem",
                    width: "100%",
                    fontFamily: "inherit",
                    fontStyle: "normal",
                    fontWeight: 400,
                    lineHeight: "16px",
                    marginTop: "0.25rem",
                    resize: "none",

                    /* Style for the placeholder text */
                    "&::placeholder ": {
                        color: "rgba(102, 112, 133, 0.40)" /* Placeholder text color */,
                    },
                }}
                minRows={3}
                value={text}
                onChange={handleChange}
            />
        </>
    );
};

export default LocationCard;
